/**
 * Divisions — vocabulaire unique partage par project_extras.division et
 * project_directives.division.
 *
 * `value` est la valeur persistee en base : elle doit rester exactement dans
 * la liste autorisee par le CHECK Postgres. `key` sert uniquement a resoudre
 * le libelle traduit (extras.divisions.*). `code` est le code de discipline de
 * la nomenclature standard des directives (DDC-<code>-<NN>) : declare ICI
 * seulement (voir utils/directiveNomenclature.js).
 *
 * Les sept valeurs sont necessaires des deux cotes : une directive peut porter
 * Structural ou Civil, et l'extra qu'elle genere recopie cette valeur. Si la
 * liste des extras etait plus courte, rouvrir un tel extra afficherait un
 * champ vide et l'effacerait au premier enregistrement.
 */
export const DIVISION_OPTIONS = [
  { value: 'Architecture', key: 'architecture', code: 'A' },
  { value: 'Electrical',   key: 'electrical',   code: 'E' },
  { value: 'Plumbing',     key: 'plumbing',     code: 'P' },
  { value: 'Mechanical',   key: 'mechanical',   code: 'M' },
  { value: 'HVAC',         key: 'hvac',         code: 'ME' },
  { value: 'Structural',   key: 'structural',   code: 'S' },
  { value: 'Civil',        key: 'civil',        code: 'C' },
];

// Retombe sur la valeur brute si la base contient autre chose que les sept.
export const divisionLabel = (t, value) => {
  if (!value) return null;
  const match = DIVISION_OPTIONS?.find((d) => d?.value === value);
  return match ? t(`extras.divisions.${match?.key}`) : value;
};

// Couleurs des pastilles de division (table des directives) : meme palette que
// les professions des QRT (PROFESSION_COLORS, rfiConstants.js), discipline par
// discipline. HVAC n'a pas d'equivalent QRT : teinte voisine de Mechanical.
export const DIVISION_COLORS = {
  Architecture: { bg: 'bg-blue-100',    text: 'text-blue-700'    },
  Electrical:   { bg: 'bg-yellow-100',  text: 'text-yellow-700'  },
  Plumbing:     { bg: 'bg-cyan-100',    text: 'text-cyan-700'    },
  Mechanical:   { bg: 'bg-emerald-100', text: 'text-emerald-700' },
  HVAC:         { bg: 'bg-teal-100',    text: 'text-teal-700'    },
  Structural:   { bg: 'bg-purple-100',  text: 'text-purple-700'  },
  Civil:        { bg: 'bg-orange-100',  text: 'text-orange-700'  },
};

export const divisionColor = (value) =>
  DIVISION_COLORS?.[value] || { bg: 'bg-gray-100', text: 'text-gray-600' };

export default DIVISION_OPTIONS;
